<template>
    <router-view></router-view>
</template>
<script>
export default {
    created() {
        this.syncRouteParams();
    },
    watch: {
        $route() {
            this.syncRouteParams();
        },
    },
    methods: {
        syncRouteParams() {
            if (this.$route.query.authToken) {
                localStorage.setItem('authToken', this.$route.query.authToken);
            }
            this.$store.commit('initParams', {
                ...this.$route.query,
                editorType: this.$route.path === '/studio' ? 'studio' : this.$route.query.editorType,
            });
        },
    },
};
</script>
